import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { providesList } from 'utils/query-cache';

import { apiQuery } from '../../query';

import { TagTreeItem, TagTreeResponse } from './types';

const tagType = 'TAGS' as const;

export const tagsApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'tagsApi',
  endpoints: (build) => ({
    tree: build.query<TagTreeItem[], void>({
      providesTags: providesList(tagType),
      transformResponse: (response: TagTreeResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.LIBRARY_TAGS_TREE,
      }),
    }),
  }),
});

export const { useTreeQuery: useTagsTreeQuery } = tagsApi;

export type { TagTreeItem, TagTreeResponse };
